
import { fromEvent as observableFromEvent, of, merge, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { GlobalService } from './services/global.service';
import { SettingsProvider } from './services/settings-provider.service';
import { AdalService } from './authentication/adal.service'
import { GraphService } from './services/graphs.service';
import { UpdateApplication } from './services/update-application.service';
import { environment } from '../environments/environment';
import { UserModel } from './models/user.model';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
	title = 'Dashboard';
	public isConnected: Observable<boolean>;
	permissionsService: Observable<any>;

	public installBtn: boolean;
	private installPromptEvent;

	constructor(
		public globals: GlobalService,
		private graph: GraphService,
		public settingsProvider: SettingsProvider,
		private adalSrv: AdalService,
		private updateApplication: UpdateApplication,
		// private user: UserModel
	) {
		if (environment.production)
			this.updateApplication.checkForAppUpdates();
		this.adalSrv.context.handleWindowCallback();
		setTimeout(() => {
			this.permissionsService = this.graph.getPermissions();
			this.permissionsService.subscribe(data => {
				console.log('Fetched Permissions:');
				console.log(data);
				console.log("Hello", data.contents.canEditOps, data.contents.canEditFin)
				this.globals.hseUser = data.contents.canEditEhs;
				this.globals.opsUser = data.contents.canEditOps;
				this.globals.finUser = data.contents.canEditFin;
				
				// this.user.modifyOps = this.globals.opsUser;
				// this.user.modifyFinance = this.globals.finUser;
				// this.globals.SetUser(user);
			}, err => {
			});
		})
	}

	ngOnInit() {
		this.globals.hasLoaded = true;
		this.isConnected = merge(
			of(navigator.onLine),
			observableFromEvent(window, 'online').pipe(map(() => true)),
			observableFromEvent(window, 'offline').pipe(map(() => false)));
		this.isConnected.subscribe(
			data => {
				this.globals.isConnected = data;
				console.log('Connected = ' + data); 
			},
			(err) => {
				console.log('app.component.ngOnInit: Error checking connection: ' + err);
			}
		);
		this.checkIfInstalled();
		this.isiOS();
	}

	public checkIfInstalled() {
		let windowNavigator: any;
		windowNavigator = window.navigator;

		const isInStandaloneMode = () => ('standalone' in window.navigator) && (windowNavigator.standalone);
		this.globals.isInstalled = isInStandaloneMode();
	}

	public isiOS() {

		var iDevices = [
			'iPad Simulator',
			'iPhone Simulator',
			'iPod Simulator',
			'iPad',
			'iPhone',
			'iPod'
		  ];
	  
		  this.globals.isiOS = false;
	  
		  if (!!navigator.platform) {
			while (iDevices.length) {
			  if (navigator.platform === iDevices.pop()){  this.globals.isiOS = true; }
			}
		  }

		console.log("app.component.isiOS: Device in use:" + navigator.platform);
		this.globals.device = navigator.platform;

		// Mobile Safari in standalone mode
		if (this.globals.isInstalled && this.globals.isiOS) {
			var manifest = document.querySelector('link[rel=manifest]');
			manifest.parentNode.removeChild(manifest);
		}
	}

	// public checkForInstallation() {
	// 	window.addEventListener('beforeinstallprompt', (event) => {
	// 		// Prevent Chrome <= 67 from automatically showing the prompt
	// 		event.preventDefault();
	// 		// Stash the event so it can be triggered later.
	// 		this.installPromptEvent = event;
	// 		// Update the install UI to notify the user app can be installed
	// 		// this.installBtn = true;
	// 	});
	// }

	public addToHomescreen() {
		// Update the install UI to remove the install button
		this.installBtn = false;
		// Show the modal add to home screen dialog
		this.installPromptEvent.prompt();
		// Wait for the user to respond to the prompt
		this.installPromptEvent.userChoice.then((choice) => {
			this.installPromptEvent = null;
		});
	}
}
